import React, {useState} from "react";
import {useForm} from "@inertiajs/react";
import {route} from "ziggy-js";
import {Dialog} from "@mui/material";
import {useModalStore} from "@/Stores/Site/ModalStore";
import Svg from "@/Components/Svg";
import Select from "@/Components/Select";
import Link from "@/Layouts/Link";
import InertiaTextInput from "@/Components/Inertia/InertiaTextInput";
import InertiaCheckboxInput from "@/Components/Inertia/InertiaCheckboxInput";

const AskQuestionFormModal = (props) => {
    const {topicsAppeals = []} = props;
    const [successMessage, setSuccessMessage] = useState('');
    const [selectedOption, setSelectedOption] = useState({
        subjectName: {},
    });

    const askQuestionFlag = useModalStore(state => state.askQuestionFlag);
    const closeModalAskQuestion = useModalStore(state => state.closeModalAskQuestion);

    const initialValues = {
        subjectName: '',
        question: '',
        checkedPersonal: true,
    }
    const form = useForm(initialValues);
    const {setData, post, processing, errors, reset} = form;

    /**
     * Обработчик select
     * @param selectedOption
     * @param name
     */
    const onHandleChangeSelect = (selectedOption, name) => {
        setSelectedOption(state => ({...state, [name]: selectedOption}));
        setData(name, selectedOption.value);
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        post(route('createAskQuestion'), {
            onSuccess: (page) => {
                setSuccessMessage(page.props.success?.message);
                reset();
            },
        });
    };

    const closeModal = () => {
        closeModalAskQuestion();
        if (successMessage) {
            setSuccessMessage('');
        }
    }

    return (
        <Dialog id={`modal`}
                className={`modal`}
                maxWidth={`sm`} //xs sm md lg xl
                open={askQuestionFlag}
                onClose={() => closeModal()}
                fullWidth>
            <div className={`dagger-box`} onClick={() => closeModal()}>
                <Svg id={`dagger-close`} className={`svg__dagger-close`} />
            </div>
            {!successMessage ?
                <>
                    <div className={`modal__header`}>
                        <p className={`modal__title`}>Задать вопрос</p>
                        <p className={`askQuestion__warningText`}>Обращаем ваше внимание!</p>
                        <p className={`askQuestion__warningText`}>
                            Обращение будет отклонено в&nbsp;случае несоответствия теме. Максимальный срок
                            предоставления ответа на&nbsp;обращение составляет 24&nbsp;часа.
                        </p>
                    </div>
                    <div className={`modal__body`}>
                        <form className={`form form--askQuestion${processing ? ' load' : ''}`} onSubmit={handleSubmit}>
                            <Select
                                name={`subjectName`}
                                value={selectedOption.subjectName}
                                onChange={(selectedOption) => onHandleChangeSelect(selectedOption, 'subjectName')}
                                options={topicsAppeals}
                                placeholder={`Тема обращения *`}
                                noOptionsMessage={() => ('Не найдено')}
                                message={errors.subjectName}
                            />
                            <InertiaTextInput
                                as={`textarea`}
                                name={`question`}
                                label={`Опишите свой вопрос *`}
                                form={form}
                            />
                            <InertiaCheckboxInput
                                name={`checkedPersonal`}
                                form={form}
                                label={
                                    <span>
                                        <span>Даю согласие на </span>
                                        <Link href={`/politika-konfidencialnosti`} className={`form__personal`}>
                                              обработку персональных данных
                                        </Link>
                                    </span>
                                }
                            />
                            <button type={`submit`} className={`button button__default`} disabled={processing}>
                                Отправить
                            </button>
                        </form>
                    </div>
                </>
                :
                <>
                    <div className={`modal__header`}>
                        <p className={`modal__title`}>Задать вопрос</p>
                    </div>
                    <div className={`modal__body`}>
                        <p className={`askQuestion__successText`}>{successMessage}</p>
                        {location.pathname !== '/home' && (
                            <p className={`askQuestion__successText`}>
                                Информация о статусе обращения будет доступна в
                                <Link href={`/home?profile=appeals`} className={`link link__answer`}>
                                    личном кабинете
                                </Link>
                            </p>
                        )}
                    </div>
                </>
            }
        </Dialog>
    );
}

export default AskQuestionFormModal;
